import * as Sentry from '@sentry/browser'

/**
 * Logs an error
 * @param {string} url
 * @param {Error} error
 * @param {boolean} rethrow
 * @param {boolean} skipK6
 */
export function captureMiddlewareError(
  url,
  error,
  rethrow = true,
  skipK6 = false,
) {
  const website = window.location.href
  const isK6Test = new URL(website).searchParams.get('skiptesting')
  if (isK6Test && skipK6) {
    return
  }

  const name = `middleware-error@${url}`

  Sentry.captureException(error, (scope) => {
    scope.setTransactionName(name)

    scope.setTag('metric', 'middleware-error')
    if (isK6Test) {
      scope.setTag('k6', 'true')
    }

    return scope
  })
  console.error(error)
  if (rethrow) {
    throw error
  }
}
